import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AdvancedSearchOptions } from "src/app/models";
import { CustomerSearchOptionsService } from "src/app/services/customer-search-options.service";

@Component({
  selector: 'app-search-filter-dialog',
  templateUrl: './search-filter-dialog.component.html',
  styleUrls: ['./search-filter-dialog.component.scss']
})
export class SearchFilterDialogComponent implements OnInit
{

  public form: FormGroup;
  public searchOptions: AdvancedSearchOptions;
  public areSearchOptionsValid: boolean;

  @Output() applyClicked = new EventEmitter<AdvancedSearchOptions>();

  constructor(
    private formBuilder: FormBuilder,
    private searchOptionsService: CustomerSearchOptionsService,
    public dialogRef: MatDialogRef<SearchFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { savedSearchOptions: AdvancedSearchOptions, areSearchOptionsValid }
  )
  {
    this.searchOptions = data.savedSearchOptions;
    this.areSearchOptionsValid = data.areSearchOptionsValid;
  }

  ngOnInit(): void
  {
    this.form = this.formBuilder.group({
      CustomerCustId: [this.searchOptions.CustomerCustId],
      CustomerAccountNo: [this.searchOptions.CustomerAccountNo],
      CustomerName: [this.searchOptions.CustomerName],
      CustomerAddress: [this.searchOptions.CustomerAddress],
      CustomerEmail: [this.searchOptions.CustomerEmail],
      CustomerPhone: [this.searchOptions.CustomerPhone],
      LocName: [this.searchOptions.LocName],
      LocAddress: [this.searchOptions.LocAddress],
      IncludeInactive: [this.searchOptions.IncludeInactive],
      IncludeTempCustomers: [this.searchOptions.IncludeTempCustomers],
      SearchFor: [this.searchOptions.SearchFor, ""]
    });
  }

  applySearchOptions(): void
  {
    Object.assign(this.searchOptions, this.form.value);
    if (this.searchOptionsService.validateSearchOptions(this.searchOptions))
    {
      localStorage.setItem('searchOptions', JSON.stringify(this.form.value));
      this.applyClicked.emit(this.searchOptions);
      this.dialogRef.close();
    } 
    else
    {
      this.searchOptionsService.showAlertDialog();
    }
  }

  resetToDefault(): void
  {
    const defaultSearchOptions = this.searchOptionsService.setCustomerSearchOptionsToDefault();
    this.form.setValue({ ...defaultSearchOptions });
  }
}